import { IDBService } from '../idb.service';

export const idbService = new IDBService();
